/* TNT B·Night commerce enhancements. Native Shopify forms remain authoritative. */
(function () {
  "use strict";

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function parseVariants(product) {
    var node = product.querySelector("[data-tb-variants]");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return [];
    }
  }

  function enhanceGallery(product) {
    var gallery = product.querySelector("[data-tnt-v2-gallery]");
    if (!gallery) return;
    var thumbs = all("[data-tnt-v2-thumb]", gallery);
    var panels = all("[data-tnt-v2-main]", gallery);

    function select(thumb) {
      var index = thumb.getAttribute("data-tnt-v2-thumb");
      thumbs.forEach(function (item) {
        var active = item === thumb;
        item.classList.toggle("on", active);
        item.setAttribute("aria-selected", active ? "true" : "false");
        item.setAttribute("tabindex", active ? "0" : "-1");
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute("data-tnt-v2-main") === index;
        panel.classList.toggle("on", active);
        panel.setAttribute("aria-hidden", active ? "false" : "true");
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.setAttribute("tabindex", index === 0 ? "0" : "-1");
      thumb.addEventListener("click", function () {
        select(thumb);
      });
      thumb.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowRight" && event.key !== "ArrowLeft" && event.key !== "Home" && event.key !== "End") return;
        event.preventDefault();
        var current = thumbs.indexOf(thumb);
        var next = event.key === "Home" ? 0 : event.key === "End" ? thumbs.length - 1 : event.key === "ArrowRight" ? (current + 1) % thumbs.length : (current - 1 + thumbs.length) % thumbs.length;
        thumbs[next].focus();
        thumbs[next].click();
      });
    });
  }

  function enhanceProduct(product) {
    var variants = parseVariants(product);
    var hidden = product.querySelector("[data-tb-variant-id]");
    var price = product.querySelector("[data-tb-price]");
    var compare = product.querySelector("[data-tb-compare]");
    var stock = product.querySelector("[data-tb-stock]");
    var sku = product.querySelector("[data-tb-sku]");
    var add = product.querySelector("[data-tb-add]");
    var form = product.querySelector("form");
    if (!hidden || !variants.length) {
      enhanceGallery(product);
      return;
    }

    function selectedValues() {
      var selected = {};
      all("[data-tb-opt]", product).forEach(function (group) {
        var active = group.querySelector(".tb-chip.on");
        if (active) selected[group.getAttribute("data-tb-opt")] = active.getAttribute("data-val");
      });
      return selected;
    }

    function sync() {
      var id = Number(hidden.value);
      var variant = variants.find(function (item) { return Number(item.id) === id; });
      if (!variant) return;

      if (price && variant.formatted) price.textContent = variant.formatted;
      if (compare) {
        var onSale = Number(variant.compare) > Number(variant.price);
        compare.classList.toggle("is-hidden", !onSale);
        compare.textContent = onSale ? variant.compareFormatted : "";
      }
      if (stock) {
        stock.classList.toggle("is-out", !variant.available);
        stock.innerHTML = variant.available ? '<span aria-hidden="true"></span>Available · made when you order' : "Currently unavailable";
      }
      if (sku) sku.textContent = variant.sku ? "SKU " + variant.sku : "";
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? (add.getAttribute("data-add") || "Add to cart") : (add.getAttribute("data-soldout") || "Sold out");
      }

      var selected = selectedValues();
      all("[data-tb-opt]", product).forEach(function (group) {
        var optionName = group.getAttribute("data-tb-opt");
        all(".tb-chip", group).forEach(function (chip) {
          var test = Object.assign({}, selected);
          test[optionName] = chip.getAttribute("data-val");
          var possible = variants.some(function (candidate) {
            return candidate.available && Object.keys(test).every(function (key) { return candidate.o[key] === test[key]; });
          });
          chip.classList.toggle("off", !possible);
          chip.setAttribute("aria-disabled", possible ? "false" : "true");
        });
      });

      if (variant.img) {
        var mediaThumb = product.querySelector('[data-tnt-v2-thumb][data-media-id="' + variant.img + '"]');
        if (mediaThumb && mediaThumb.getAttribute("aria-selected") !== "true") mediaThumb.click();
      }
    }

    function chooseVariant() {
      var selected = selectedValues();
      var variant = variants.find(function (candidate) {
        return Object.keys(selected).every(function (key) { return candidate.o[key] === selected[key]; });
      });
      if (!variant) {
        if (add) {
          add.disabled = true;
          add.textContent = add.getAttribute("data-unavail") || "Choose an available option";
        }
        return;
      }
      hidden.value = variant.id;
      try {
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("variant", variant.id);
        window.history.replaceState(null, "", nextUrl.pathname + nextUrl.search + nextUrl.hash);
      } catch (error) {
        /* URL updates are a convenience; the product form remains valid. */
      }
      sync();
    }

    all("[data-tb-opt] .tb-chip", product).forEach(function (chip) {
      chip.addEventListener("click", function () {
        var group = chip.closest("[data-tb-opt]");
        all(".tb-chip", group).forEach(function (item) {
          var active = item === chip;
          item.classList.toggle("on", active);
          item.setAttribute("aria-pressed", active ? "true" : "false");
        });
        var selectedLabel = group.querySelector("[data-tb-sel]");
        if (selectedLabel) selectedLabel.textContent = chip.getAttribute("data-val");
        chooseVariant();
      });
    });

    var quantity = product.querySelector("[data-tb-qty]");
    if (quantity) {
      var minus = product.querySelector("[data-tb-minus]");
      var plus = product.querySelector("[data-tb-plus]");
      if (minus) minus.addEventListener("click", function () { quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener("click", function () { quantity.value = (parseInt(quantity.value, 10) || 1) + 1; });
      quantity.addEventListener("change", function () {
        quantity.value = Math.max(1, parseInt(quantity.value, 10) || 1);
      });
    }

    if (form && add) {
      form.addEventListener("submit", function () {
        if (add.disabled) return;
        add.setAttribute("aria-busy", "true");
        add.textContent = add.getAttribute("data-adding") || "Adding…";
      });
    }

    enhanceGallery(product);
    sync();
  }

  function enhanceFilters() {
    all("[data-tb-sort]").forEach(function (select) {
      select.addEventListener("change", function () {
        if (select.form) {
          if (select.form.requestSubmit) select.form.requestSubmit();
          else select.form.submit();
        }
      });
    });

    if (window.matchMedia("(max-width: 720px)").matches && window.location.hash.indexOf("#shop?") === -1) {
      all("[data-tb-filter-panel]").forEach(function (panel) {
        panel.removeAttribute("open");
      });
    }
  }

  function enhanceCart() {
    var summary = document.querySelector(".cart-page__summary, .cart-summary, [class*='cart-page-summary']");
    if (!summary || summary.querySelector(".tb-cart-order-note")) return;
    var note = document.createElement("aside");
    note.className = "tb-cart-order-note";
    note.setAttribute("aria-label", "Made-to-order shipping reminder");
    note.innerHTML = "<strong>Everything here is made to order.</strong><span>Production normally takes 2–7 business days. Shipping is calculated at checkout, and tracking is emailed when the order leaves production.</span><a href=\"/policies/shipping-policy\">Shipping details</a>";
    var checkout = summary.querySelector("button[name='checkout'], input[name='checkout'], [href*='/checkout']");
    if (checkout && checkout.parentNode) checkout.parentNode.insertBefore(note, checkout);
    else summary.insertBefore(note, summary.firstChild);
  }

  function init() {
    all("[data-tnt-v2-product]").forEach(enhanceProduct);
    enhanceFilters();
    enhanceCart();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  window.addEventListener("pageshow", function () {
    all("[data-tb-add][aria-busy='true']").forEach(function (button) {
      button.removeAttribute("aria-busy");
      button.textContent = button.getAttribute("data-add") || "Add to cart";
    });
  });
})();
